import api from './api';

export const sblViewService = {
  /**
   * Get default month range (last 12 months)
   */
  getDefaultRange: async () => {
    const response = await api.get('/sbl-view/default-range');
    return response.data;
  },

  /**
   * Get month-wise billable summary for a project
   * @param {string} projectCode - Project code
   * @param {string} startMonth - Start month (YYYY-MM-DD format)
   * @param {string} endMonth - End month (YYYY-MM-DD format)
   */
  getSummary: async (projectCode, startMonth, endMonth) => {
    const params = new URLSearchParams({ project_code: projectCode });

    if (startMonth) {
      params.append('start_month', startMonth);
    }
    if (endMonth) {
      params.append('end_month', endMonth);
    }

    const response = await api.get(`/sbl-view/summary?${params.toString()}`);
    return response.data;
  },

  /**
   * Export SBL View as Excel
   * @param {string} projectCode - Project code
   * @param {string} startMonth - Start month (YYYY-MM-DD format)
   * @param {string} endMonth - End month (YYYY-MM-DD format)
   */
  exportExcel: async (projectCode, startMonth, endMonth) => {
    const response = await api.post(
      '/sbl-view/export-excel',
      {
        project_code: projectCode,
        start_month: startMonth,
        end_month: endMonth,
      },
      {
        responseType: 'blob',
      }
    );
    return response.data;
  },

  /**
   * Export SBL View as PDF
   * @param {string} projectCode - Project code
   * @param {string} startMonth - Start month (YYYY-MM-DD format)
   * @param {string} endMonth - End month (YYYY-MM-DD format)
   */
  exportPDF: async (projectCode, startMonth, endMonth) => {
    const response = await api.post(
      '/sbl-view/export-pdf',
      {
        project_code: projectCode,
        start_month: startMonth,
        end_month: endMonth,
      },
      {
        responseType: 'blob',
      }
    );
    return response.data;
  },
};

export default sblViewService;
